/**
 * TRL bucket type definition.
 */
export type Bucket = {
  label: string;
  range: { max: number; min: number };
};

/**
 * TRL bucket configuration for grouping Technology Readiness Levels.
 *
 * Current grouping:
 * - Discovery: TRL 1-3
 * - Development: TRL 4-6
 * - Deployment: TRL 7-9
 *
 * Alternative grouping (not active, but easy to swap):
 * - Fundamental Research: TRL 1-2
 * - Research & Development (R&D): TRL 3-6
 * - Pilot & Demonstration: TRL 7-8
 * - Early Adoption/Deployment: TRL 9
 */
export const TRL_BUCKETS: Bucket[] = [
  { label: 'Discovery', range: { max: 3, min: 1 } },
  { label: 'Development', range: { max: 6, min: 4 } },
  { label: 'Deployment', range: { max: 9, min: 7 } },
];

/**
 * Descriptions for each TRL bucket, keyed by label.
 */
export const TRL_BUCKET_DESCRIPTIONS: Record<string, string> = {
  Deployment: 'System demonstration and operational readiness.',
  Development: 'Technology validation and system integration.',
  Discovery: 'Early-stage research and proof of concept.',
};

export const getTrlBucketForScore = (score: number | null | undefined): Bucket | null => {
  if (!score) return null;

  return TRL_BUCKETS.find((bucket) => score >= bucket.range.min && score <= bucket.range.max) ?? null;
};
